/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentTeamResponse } from './TournamentTeamResponse';
import {
    TournamentTeamResponseFromJSON,
    TournamentTeamResponseFromJSONTyped,
    TournamentTeamResponseToJSON,
    TournamentTeamResponseToJSONTyped,
} from './TournamentTeamResponse';
import type { PenaltyRecord } from './PenaltyRecord';
import {
    PenaltyRecordFromJSON,
    PenaltyRecordFromJSONTyped,
    PenaltyRecordToJSON,
    PenaltyRecordToJSONTyped,
} from './PenaltyRecord';

/**
 * Result of applying a penalty to a team
 * @export
 * @interface PenaltyApplicationResponse
 */
export interface PenaltyApplicationResponse {
    /**
     * 
     * @type {TournamentTeamResponse}
     * @memberof PenaltyApplicationResponse
     */
    team: TournamentTeamResponse;
    /**
     * 
     * @type {PenaltyRecord}
     * @memberof PenaltyApplicationResponse
     */
    penaltyApplied: PenaltyRecord;
    /**
     * 
     * @type {string}
     * @memberof PenaltyApplicationResponse
     */
    message: string;
}

/**
 * Check if a given object implements the PenaltyApplicationResponse interface.
 */
export function instanceOfPenaltyApplicationResponse(value: object): value is PenaltyApplicationResponse {
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('penaltyApplied' in value) || value['penaltyApplied'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function PenaltyApplicationResponseFromJSON(json: any): PenaltyApplicationResponse {
    return PenaltyApplicationResponseFromJSONTyped(json, false);
}

export function PenaltyApplicationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PenaltyApplicationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'team': TournamentTeamResponseFromJSON(json['team']),
        'penaltyApplied': PenaltyRecordFromJSON(json['penaltyApplied']),
        'message': json['message'],
    };
}

export function PenaltyApplicationResponseToJSON(json: any): PenaltyApplicationResponse {
    return PenaltyApplicationResponseToJSONTyped(json, false);
}

export function PenaltyApplicationResponseToJSONTyped(value?: PenaltyApplicationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': TournamentTeamResponseToJSON(value['team']),
        'penaltyApplied': PenaltyRecordToJSON(value['penaltyApplied']),
        'message': value['message'],
    };
}

